import PinGate from './PinGate';
import JobApplicationsList from './JobApplicationsList';
import './JobApplications.css';

export default function JobApplications() {
    return (
        <div className="basicContainer job-applications-container">
            <div className="job-applications-wrapper">
                <PinGate>
                    <JobApplicationsList />
                </PinGate>
            </div>
        </div>
    );
}
